import { z } from "zod";

export const ProfileResponseSchema = z.object({
  id: z.string(),
  email: z.string(),
  githubUserId: z.number().nullable(),
  avatarUrl: z.string().nullable(),
  login: z.string().nullable(),
  role: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type ProfileResponse = z.infer<typeof ProfileResponseSchema>;

export const LogoutResponseSchema = z.object({
  success: z.boolean(),
});

export type LogoutResponse = z.infer<typeof LogoutResponseSchema>;

export const ApiTokenResponseSchema = z.object({
  id: z.string(),
  name: z.string(),
  scopes: z.array(z.string()).nullable(),
  lastUsedAt: z.date().nullable(),
  expiresAt: z.date().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
  revokedAt: z.date().nullable(),
});

export type ApiTokenResponse = z.infer<typeof ApiTokenResponseSchema>;

export const TokensListResponseSchema = z.object({
  tokens: z.array(ApiTokenResponseSchema),
});

export type TokensListResponse = z.infer<typeof TokensListResponseSchema>;

export const RevokeTokenRequestSchema = z.object({
  tokenId: z.string().uuid("Token ID must be a valid UUID"),
});

export type RevokeTokenRequest = z.infer<typeof RevokeTokenRequestSchema>;

export const CliExchangeRequestSchema = z.object({
  name: z
    .string()
    .min(1, "Token name is required")
    .max(100, "Token name too long")
    .optional(),
  scopes: z.array(z.string()).max(10, "Too many scopes").optional(),
  ttlSeconds: z
    .number()
    .int()
    .min(60, "TTL must be at least 60 seconds")
    .max(60 * 60 * 24 * 365, "TTL cannot exceed 1 year")
    .optional(),
});

export type CliExchangeRequest = z.infer<typeof CliExchangeRequestSchema>;

export const CliExchangeResponseSchema = z.object({
  token: z.string(),
  expiresAt: z.date().nullable(),
  scopes: z.array(z.string()).nullable(),
});

export type CliExchangeResponse = z.infer<typeof CliExchangeResponseSchema>;
